module.exports = __webpack_public_path__ + "static/img/1025_big.f0df53c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1025_big.png
// module id = o5vE
// module chunks = 1